export default __webpack_public_path__ + "78c862070d55908d7d0108fb6842e25c.svg";